import React, { Suspense, lazy } from 'react';
import { withRouter } from 'react-router-dom';
import { MOSQUE_BG } from '../../common/images-s3';
import { scrollTo } from '../../common';

const ImageLoader = lazy(() => import('../../common/image-loader'));

class PageConnectionError extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            _props: this.getErrorContent(props.location.pathname)
        };
    }

    componentDidMount() {
        scrollTo();
    }

    getErrorContent(pathname) {
        if (pathname === '/token-expired') {
            return {
                title: 'Oops!',
                heading: 'Token Expired',
                subtitle: 'Your token has expired. Please scan again to proceed.'
            };
        } else {
            return {
                title: '404',
                heading: 'Page Not Found',
                subtitle: 'The page you are looking for does not exist.'
            };
        }
    }

    render() {
        const { title, heading, subtitle } = this.state._props;

        return (
            <div className="page-error">
                <div className='error-body page-not-found'>
                    <div className='mask'></div>
                    <Suspense fallback={null}>
                        <ImageLoader type="image" src={MOSQUE_BG} />
                    </Suspense>
                    <div className="c-error">
                        <h3 className='fof'>{title}</h3>
                        <h4>{heading}</h4>
                        <p>{subtitle}</p>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(PageConnectionError);
